import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, Validators, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { ApiResponse } from 'src/app/shared/models/api-response.model';

import { ValidateControls } from 'src/app/shared/validations/ValidateControls';

import { AttachmentDto, AttachmentFileType } from 'src/app/shared/common/attachment/attachment';
import { customAttachmentValidator } from 'src/app/shared/validations/custom-attachment-validator';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { CompanyService } from 'src/app/modules/services/license/company/services/company.service';
import { Company, AddCompany, CompanyRequestContactAddDto } from 'src/app/modules/services/license/company/models/Company';
import { CompanyResponseDTO } from 'src/app/modules/services/license/company/models/CompanyResponseDTO';
import { EditCompanyComponent } from 'src/app/modules/services/license/company/components/edit-company/edit-company.component';
import { toGregorian, toHijri } from 'hijri-converter';
import { CacheService } from '../../services/cashe-service';

@Component({
  selector: 'app-complete-company',
  templateUrl: './complete-company.component.html',
  styleUrls: ['./complete-company.component.css']
})
export class CompleteCompanyComponent extends BaseComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    public override router: Router,
    private route: ActivatedRoute,
    private _companyprofileService: CompanyService,
    public override translate?: TranslateService
  ) {
    super();
  }
  @Input() CompanyRequestId: string;
  @Input() isSendButton: boolean = true;

  public attachmentFileType = AttachmentFileType;
  CommitmentForm_Attach_List: AttachmentDto[] = [];
  OtherAttachments_Attach_List: AttachmentDto[] = [];

  cR_Attach_List: AttachmentDto[] = [];
  //#region Variables Declaration
  public Company: AddCompany = new AddCompany();
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.SaudiArabia, CountryISO.Egypt];
  createForm!: FormGroup;
  gregorianDate: string;
  //#endregion

  get companyRequestContacts(): FormArray {
    return <FormArray>this.createForm.get('companyRequestContacts');
  }
  get companyStructures(): FormArray {
    return <FormArray>this.createForm.get('companyStructures');
  }
  EMAIL_PATTERN: string =
    "^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

  createContact(companyRequestContacts: CompanyRequestContactAddDto): FormGroup {
    if (companyRequestContacts == null) {
      return this.fb.group({
        companyProfileRequestId: [null],
        id: [null],
        contactName: [null, [Validators.required, Validators.maxLength(100), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
        iqamaNum: [null, [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateControls.IsValidNumber, EditCompanyComponent.CheckIfIqamaStartWit_1_Or_2]],
        jobTitle: [null, [Validators.required, Validators.maxLength(200), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
        department: [null, [Validators.required, Validators.maxLength(200), ValidateControls.IsValidTextNotContainsNumbers]],
        email: ['', [Validators.required, Validators.maxLength(200), Validators.email, Validators.pattern(this.EMAIL_PATTERN)]],
        phone: [null, [Validators.required]],
      })
    }

    return this.fb.group({
      companyProfileRequestId: [companyRequestContacts.companyProfileRequestId],
      id: [companyRequestContacts.id],
      contactName: [companyRequestContacts.contactName, [Validators.required, Validators.maxLength(100), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
      iqamaNum: [companyRequestContacts.iqamaNum, [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateControls.IsValidNumber]],
      jobTitle: [companyRequestContacts.jobTitle, [Validators.required, Validators.maxLength(200), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
      department: [companyRequestContacts.department, [Validators.required, Validators.maxLength(200), ValidateControls.IsValidTextNotContainsNumbers]],
      email: [companyRequestContacts.email, [Validators.required, Validators.maxLength(200), Validators.email, Validators.pattern(this.EMAIL_PATTERN)]],
      phone: [companyRequestContacts.phone, [Validators.required]],
    })
  }
  numberfields: number = 0;

  CreateStructures(companyStructures): FormGroup[] {
    this.numberfields = this.Company.companyStructures.length;
    // const fieldItems = this.createForm.get('companyStructures') as FormArray;
    // fieldItems.clear(); // Clear existing items
    // for (let i = 0; i < this.numberfields; i++) {
    //   fieldItems.push(this.createCompanyStructure(i + 1 , this.Company.companyStructures[i])); // Push new items
    // }


    var myList = [];
    for (let i = 0; i < this.Company.companyStructures.length; i++) {
      var item = this.fb.group({
        id: [this.Company.companyStructures[i].id],
        name: [this.Company.companyStructures[i].name, [Validators.required, Validators.maxLength(100), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
        iqamaNum: [this.Company.companyStructures[i].iqamaNum, [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateControls.IsValidNumber]],
        companyExecutiveManagement: [this.Company.companyStructures[i].companyExecutiveManagement, [Validators.required, Validators.maxLength(200), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
        administrativePosition: [this.Company.companyStructures[i].administrativePosition, [Validators.required, Validators.maxLength(200), ValidateControls.IsValidTextNotContainsNumbers]],
        order: [this.Company.companyStructures[i].order, [Validators.required]],
       dateOfBirth :[this.Company.companyStructures[i].dateOfBirth, [Validators.required]],

      });
      myList.push(item);
    }
    return myList;
  }

  createCompanyStructure(myOrder, companyStructures): FormGroup {

    if (companyStructures == null) {
      return this.fb.group({
        id: [null],
        name: ["", [Validators.required, Validators.maxLength(100), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
        iqamaNum: [null, [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateControls.IsValidNumber]],
        companyExecutiveManagement: [null, [Validators.required, Validators.maxLength(200), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
        administrativePosition: [null, [Validators.required, Validators.maxLength(200), ValidateControls.IsValidTextNotContainsNumbers]],
        order: [myOrder, [Validators.required]],
        dateOfBirth :[null, [Validators.required]]

      })
    }

    return this.fb.group({
      id: [companyStructures.id],
      name: [companyStructures.name, [Validators.required, Validators.maxLength(100), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
      iqamaNum: [companyStructures.iqamaNum, [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateControls.IsValidNumber]],
      companyExecutiveManagement: [companyStructures.companyExecutiveManagement, [Validators.required, Validators.maxLength(200), Validators.minLength(2), ValidateControls.IsValidTextNotContainsNumbers]],
      administrativePosition: [companyStructures.administrativePosition, [Validators.required, Validators.maxLength(200), ValidateControls.IsValidTextNotContainsNumbers]],
      order: [myOrder, [Validators.required]],
      dateOfBirth: [companyStructures.dateOfBirth, [Validators.required]],

    })

  }
  

  changeNumberFields(): void {
    const fieldItems = this.createForm.get('companyStructures') as FormArray;
    // fieldItems.clear(); // Clear existing items
    // for (let i = 0; i < this.numberfields; i++) {
    //   var item = this.createCompanyStructure(i+1);
    //   fieldItems.push(item); // Push new items
    // }

    var item = this.createCompanyStructure(this.numberfields, null);
    fieldItems.push(item); // Push new items
    this.numberfields = this.numberfields + 1;

  }
  RemoveStructureItem(index): void {
    this.numberfields = this.numberfields - 1;
    const fieldItems = this.createForm.get('companyStructures') as FormArray;

    if (index !== -1) fieldItems.removeAt(index)

  }

  static CheckIfIqamaStartWit_1_Or_2(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp(/\d+/g);
    return text == null || text.startsWith('1') || text.startsWith('2') || !regex.test(text)
      ? null
      : { IsValidRaqmiNumber: true };
  };
  get CompanyEmail() {
    return this.createForm.get('email')
  }

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }

  CreateForm() {

    this.createForm = this.fb.group({
      cRNumber: [{ value: this.Company.crNumber, disabled: true }],
      address: ['', [Validators.required, Validators.maxLength(200)]],
      companyActivity: ['', [Validators.required, Validators.maxLength(200)]],
      identifier: ['', [Validators.required, Validators.maxLength(25)]],
      website: ['', [Validators.required, Validators.maxLength(255)]],
      email: ['', [Validators.required, Validators.maxLength(200), Validators.email]],
      phone: ['', [Validators.required]],
      ownership: ['', [Validators.required, Validators.maxLength(200)]],
      CompanyNameAr: ['', [Validators.required]],
      CompanyNameEn: ['', [Validators.required]],
      DataAccuracyDeclaration: [false, [Validators.requiredTrue]],
      TermsAndConditionsAgreement: [false, [Validators.requiredTrue]],
      CommitmentForm_Attach: [[], [customAttachmentValidator()]],
      OtherAttachments_Attach: [[]],
      cR_Attach: [[], [customAttachmentValidator()]],
      expirationDate: ['', [Validators.required]],
      expirationDateM: ['', [Validators.required]],
      companyRequestContacts: this.fb.array(
        [
          this.createContact(null),
          this.createContact(null)
        ],
        Validators.required),
      companyStructures: this.fb.array([]),
    });

  }
  InitForm() {
    this.numberfields = this.Company?.companyStructures?.length;
    this.createForm = this.fb.group({
      cRNumber: [{ value: this.Company==null|| this.Company?.crNumber==null?'':this.Company?.crNumber , disabled: true }],
      address: [this.Company==null|| this.Company?.address == null?'':this.Company?.address, [Validators.required, Validators.maxLength(200)]],
      companyActivity: [this.Company==null|| this.Company?.companyActivity==null?'':this.Company?.companyActivity, [Validators.required, Validators.maxLength(200)]],
      identifier: [{ value:this.Company==null || this.Company.identifier==null?'':this.Company.identifier, disabled: true }],
      website: [this.Company==null|| this.Company?.website == null?'':this.Company?.website, [Validators.required, Validators.maxLength(255)]],
      email: [this.Company==null|| this.Company?.email ==null?'':this.Company?.email, [Validators.required, Validators.maxLength(200), Validators.email]],
      phone: [this.Company==null|| this.Company?.phone ==null?'':this.Company?.phone, { disabled: true }, [Validators.required, Validators.maxLength(200)]],
      ownership: [this.Company==null|| this.Company?.ownership==null?'':this.Company?.ownership, [Validators.required, Validators.maxLength(200)]],
      CompanyNameAr: [{ value: this.Company==null|| this.Company.companyNameAr==null?'':this.Company.companyNameAr, disabled: true }, [Validators.required, Validators.maxLength(200)
      ]],
      CompanyNameEn: [this.Company==null|| this.Company?.companyNameEn == null? '':this.Company?.companyNameEn, [Validators.required, Validators.maxLength(200)
      ]],
      DataAccuracyDeclaration: [false, [Validators.requiredTrue]],
      TermsAndConditionsAgreement: [false, [Validators.requiredTrue]],
      CommitmentForm_Attach: [[], [customAttachmentValidator()]],
      OtherAttachments_Attach: [[]],
      cR_Attach: [[], [customAttachmentValidator()]],
      expirationDate: [{ value:this.Company==null||  this.Company.expirationDate == null?'':this.Company.expirationDate, disabled: true }],
      expirationDateM: [{ value: null, disabled: true }],

      companyRequestContacts: this.fb.array(
        [
          this.createContact(this.Company?.companyRequestContacts[0]),
          this.createContact(this.Company?.companyRequestContacts[1])
        ],
        Validators.required),
      companyStructures: this.fb.array(
        this.CreateStructures(this.Company==null|| this.Company.companyStructures==null?'':this.Company.companyStructures),
        Validators.required) ,

    });
    this.convertHijriToGregorian(this.Company==null|| this.Company.expirationDate ==null?'': this.Company.expirationDate.toString());
    this.populateAttachments();

    this.GetDefaultItem();
  }
  GetDefaultItem(): void {
    const fieldItems = this.createForm.get('companyStructures') as FormArray;
  if(fieldItems.length==0){
       fieldItems.push(this.createCompanyStructure(0 , null)); // Push new items
        this.numberfields = this.numberfields + 1;
  }
     

  }
  
  DisabledClass: string = 'READONLYYYY';
  ngOnInit() {
    this.CreateForm();
    this.route.params.subscribe((param: Params) => {
      this.CompanyRequestId = param["id"];
      this.GetCompanyProfileRequestById(this.CompanyRequestId).then(() => this.InitForm());
    });

    // if(this.numberfields ==0){
    //   this.changeNumberFields();
    // }
  }
  setFile(formGroup: FormGroup, controlName: string, att: AttachmentDto[]) {
    formGroup.controls[controlName].patchValue(att);
  }
  populateAttachments() {
    this.setFile(this.createForm, 'CommitmentForm_Attach', this.Company.commitmentForm_Attach);
    this.setFile(this.createForm, 'OtherAttachments_Attach', this.Company.otherAttachments_Attach);
    this.setFile(this.createForm, 'cR_Attach', this.Company.cR_Attach);

    this.createForm.controls.expirationDate.setValue(formatDate(this.Company.expirationDate, 'yyyy-MM-dd', "en-US"));
  }

  public GetCompanyProfileRequestById(id: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._companyprofileService.getCompanyProfileRequestById(id).subscribe((data: ApiResponse<AddCompany>) => {
        this.Company = data.value;
        
        resolve();

      });
    });
  }

  addMonths(date: Date, months: number): Date {
    let result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
  }

  enableSubmitBtn: Boolean = true;
  public EditCompanyProfile() {
    var myCom = this.Company;
    var phone_Num = this.createForm.value.phone.internationalNumber;
    if (phone_Num == undefined) {
      phone_Num = this.createForm.value.phone;
    }
    //delete this.createForm.value.Phone;

    var firstPhoneNumber = this.createForm.value.companyRequestContacts[0].phone.internationalNumber;
    var secondPhoneNumber = this.createForm.value.companyRequestContacts[1].phone.internationalNumber;

    var firstPhone = this.createForm.value.companyRequestContacts[0].phone;
    var secondPhone = this.createForm.value.companyRequestContacts[1].phone;

    this.Company = Object.assign({}, this.createForm.value);
    this.Company.phone = phone_Num;
    this.Company.companyRequestContacts[0].phone = firstPhoneNumber;
    this.Company.companyRequestContacts[1].phone = secondPhoneNumber;

    // Get today's date
    const currentDate = new Date();
    // Example: Adding 2 months to the current date
    const dateAfter3Months = this.addMonths(this.Company.expirationDate, 3);
    if (dateAfter3Months >= currentDate) {
      this.info('Company.YouCannotAddCompanyBecauseOfExpirationDate');
      this.createForm.disable();
      this.enableSubmitBtn = false;
    } else {
      this.createForm.enable();
      this.enableSubmitBtn = true;
    }
    this.Company.id = myCom.id;
    this.Company.companyNameAr = this.createForm.value.CompanyNameAr;
    this.Company.crNumber =CacheService.getCurrentCompany();;
    this.Company.identifier = this.createForm.value.identifier;
    this.Company.expirationDate = this.createForm.value.expirationDate;
    this._companyprofileService.EditCompanyProfileRequest(this.Company).subscribe({
      next: (result: ApiResponse<boolean>) => {

        if (result.success) {
          this.done('shared.doneSuccessfully');
          this.router.navigate(['/']);
        } //else this.toastr.error(result.message);
      },
    });
  }

  public OnSubmit(formVal: any) {
    if (this.createForm.valid) {
      this.confirm("shared.save").then((result) => {
        if (!result.isConfirmed) return;
        this.EditCompanyProfile();
      });
    }
  }

  convertHijriToGregorian(hijriDate: string) {
    
    let date = formatDate(hijriDate, 'yyyy-MM-dd', "en-US");
    this.createForm.controls.expirationDateM.setValue(date);



    //// Assuming the format is 'YYYY-MM-DD'
    //const gregorian = moment(hijriDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD');

    //// this.gregorianDate = gregorian;
    //var convertDate = new Date(hijriDate);
    //var y = convertDate.getFullYear();
    //var m = convertDate.getMonth();
    //var d = convertDate.getDay();
    //var format = toGregorian(y, m, d);
    //var today = new Date()
    //today.setFullYear(format.gy)
    //today.setMonth(format.gm)
    //today.setDate(format.gd)
    //var fullDate = today.toString();
    //debugger
    //this.createForm.controls.expirationDateM.setValue(formatDate(fullDate, 'yyyy-MM-dd', "en-US"));

    //console.log(`Gregorian Date: ${today}`);
  }
}
